module.exports = __webpack_public_path__ + "static/media/arrow-naranja.8ac6065a.svg";